import { IconCheckSquare, IconAngleRight, IconRedo } from '@maia/icons';
import { PageHeader, StaticNotification, InfoCard, Button } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/add-insurance/$customer/special-send',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { customer } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De maatwerk aanvraag is verstuurd"
        description="De maatwerkofferte zal naar de broker verstuurd worden en niet naar de klant."
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Let op!</span> De maatwerkofferte zal
          naar de broker verstuurd worden en niet naar de klant.
        </StaticNotification>

        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconCheckSquare}
              title="Taakcreatie voor acceptant"
              description="Er wordt een taak aangemaakt voor de acceptant met alle informatie. "
            />
          </li>
          <li>
            <InfoCard
              icon={IconRedo}
              title="Terugkoppeling naar broker"
              description="Na het klaarzetten van de offerte zal er een taak aangemaakt worden voor de broker"
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          {/* // TODO: Add link to aanvraag */}
          <Link to="/customers/$guid" params={{ guid: customer }}>
            <Button intent="primary" iconRight={IconAngleRight}>
              Naar aanvraag
            </Button>
          </Link>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </div>
  );
}
